import { atom } from 'recoil';
import defaultParticipants from 'ProjectManager/Project/Introductions/Create/recoil/participants/defaultParticipants';

const participantsAtom = atom({
    key: 'projectManagement_introduction_create_participants',
    default: defaultParticipants,
});

export default participantsAtom;
